<template>
  <div class="hello">
    <el-row>
      <el-col :xs="24">
        <div class="box1">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="16">
              <el-carousel indicator-position="outside" :interval="5000">
                <el-carousel-item v-for="item in box1" :key="item.title">
                  <div class="bannerbox animated">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.content }}</p>
                    <el-button type="primary" round>
                      <router-link :to="{path:'/solution',query: {id: 2}}">了解详情</router-link>
                    </el-button>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </el-col>
            <el-col :xs="0" :sm="8"></el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <div class="box2">
        <el-col :span="20" :offset="2">
          <el-row class="box2_row">
            <el-col :xs="24" :sm="12">
              <div class="box2_contentleft animated">
                <p class="box2_title"><span>关于</span><span>广州锐动网络科技有限公司</span></p>
                <p>
                  广州锐动网络科技有限公司是一家互联网技术服务商，可根据具体项目需求，提供网站与业务系统开发、系统对接、部署及运维等技术支持。客户使用的相关资源由客户自行选定的第三方服务商提供，我们不经营相关资源。</p>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12">
              <div class="box2_contentright animated">
                <img src="../assets/3917_jdbbi4ow.png" alt="">
              </div>
            </el-col>
          </el-row>
          <el-row class="box2_row">
            <el-col :xs="24" :sm="12">
              <div class="box2_contentleft1 animated">
                <img src="../assets/3917_jdbbkb3z.png" alt="">
              </div>
            </el-col>
            <el-col :xs="24" :sm="12">
              <div class="box2_contentright1 animated">
                <p class="box2_title"><span>企业</span><span>技术服务</span></p>
                <p>
                  可根据具体项目需求提供以下相关技术支持，具体服务内容及范围以双方约定为准。</p>
                <div class="box2_contentleft1_down animated">
                  <el-row type="flex" justify="space-around">
                    <el-col :span="4">
                      <img style="width: 50px;" src="../assets/3917_jdbbqs8p.png" alt="">
                      <p class="pic_title">网站开发</p>
                    </el-col>
                    <el-col :span="4">
                      <img style="width: 50px;" src="../assets/3917_jdbbqzdp.png" alt="">
                      <p class="pic_title">应用集成</p>
                    </el-col>
                    <el-col :span="4">
                      <img style="width: 50px;" src="../assets/3917_jdbbr3wu.png" alt="">
                      <p class="pic_title">数据存储</p>
                    </el-col>
                  </el-row>
                  <el-row type="flex" justify="space-around">
                    <el-col :span="4">
                      <img style="width: 50px;" src="../assets/3917_jdbbr8l9.png" alt="">
                      <p class="pic_title">部署实施</p>
                    </el-col>
                    <el-col :span="4">
                      <img style="width: 50px;" src="../assets/3917_jdbbrdgr.png" alt="">
                      <p class="pic_title">运维支持</p>
                    </el-col>
                    <el-col :span="4">
                      <img style="width: 50px;" src="../assets/3917_jdbbrify.png" alt="">
                      <p class="pic_title">技术咨询</p>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {

      box1: [{
        title: '企业信息化技术服务',
        content: '根据具体项目需求及双方约定，提供网站与业务系统开发、系统对接、部署及运维等技术支持'
      }, {
        title: '企业IT系统相关技术支持',
        content: '可根据项目约定，提供第三方平台选型建议、系统设计、部署及运维相关技术支持'
      }]
    }
  },
  methods: {
    beforeEnter: function (val) {
      console.log(val, "before enter")
    },
    enter: function (val) {
      console.log("enter")
    },
    jqfun: function () {
      function scrollnumber(element, cssname, offset) {
        var a, b, c, d;
        d = $(element).offset().top;
        a = eval(d + offset);
        b = $(window).scrollTop();
        c = $(window).height();
        if (b + c > a) {
          $((element)).addClass((cssname));
        }
      }

      function scrollfun() {
        scrollnumber(".bannerbox", 'fadeInLeft slow', 100);
        scrollnumber(".box2_contentleft", 'fadeInLeft slow', 100);
        scrollnumber(".box2_contentleft1", 'fadeInLeft slow', 100);
        scrollnumber(".box2_contentleft2", 'fadeInLeft slow', 100);

        scrollnumber(".box2_contentleft1_down", 'fadeInUp delay-1s', 100);
        scrollnumber(".box2_contentleft2_down", 'fadeInUp delay-1s', 100);

        scrollnumber(".box2_contentright", 'fadeInRight slow', 100);
        scrollnumber(".box2_contentright1", 'fadeInRight slow', 100);
        scrollnumber(".box2_contentright2", 'fadeInRight slow', 100);

        scrollnumber(".elcarouselbox", 'slideInUp slower', 100);

        scrollnumber(".card1", 'slideInUp slow', 100);
        scrollnumber(".card2", 'slideInUp slow', 100);
        scrollnumber(".card3", 'slideInUp slow', 100);

      }

      $(document).ready(function (e) {
        scrollfun();
        $(window).scroll(function () {
          scrollfun();
        });
      });

    }
  },
  /* 钩子函数 */
  beforeCreate: function () { //创建前状态

  },
  create: function () { //创建完毕状态

  },
  beforeMount: function () { //挂载前状态

  },
  mounted: function () { //挂载结束状态
    window.addEventListener('scroll', this.scrollnumber);
  },
  beforeUpdate: function () { //更新前状态

  },
  uptated: function () { //更新完成状态

  },
  beforeDestroy: function () { //销毁前状态

  },
  destroyed: function () { //销毁完成状态

  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}

/* box1 */
.box1 {
  margin: 0;
  height: 800px;
  width: 100%;
  background: url(../assets/3917_jdbaxb26.jpg) no-repeat center center;
  overflow: hidden;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.box1 .el-row {
  padding-top: 150px;
}

.box1 a:-webkit-any-link {
  color: #FFFFFF;
}

/* box2 */
.box2 {
  width: 100%;
  overflow: hidden;
  margin: 0;
  color: #000000;
  background: url(../assets/3917_jdbbe20e.png) no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.box2 .box2_row {
  margin: 100px auto;
}

.box2 .el-main {
  line-height: 10px;

}

.box2 img {
  width: 80%;
}

.box2 .box2_title span {
  font-size: 24px;
  color: #CF9236;
  font-weight: 700;
}

.box2 .box2_title span:first-child {
  color: #000000;
}

.box2 .box2_list,
.box2 .box2_list li {
  float: left;
  margin: 20px 42px;
}

.pic_title {
  color: #CF9236;
}

.box2 p {
  color: #000000;
}

.el-card {
  /* margin: 30px auto; */
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue